import { Controller } from "@hotwired/stimulus";
import intlTelInput from "intl-tel-input";

export default class extends Controller {
  initialize() {
    const hiddenInput = document.createElement("input");
    hiddenInput.type = "hidden";
    hiddenInput.name = this.element.name;
    hiddenInput.value = this.element.value;
    this.element.insertAdjacentElement("afterend", hiddenInput);

    const telInput = intlTelInput(this.element, {
      preferredCountries: ["cr"],
      autoPlaceholder: "polite",
      separateDialCode: true,
      formatOnDisplay: true,
      utilsScript:
        "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.16/js/utils.min.js"
    });

    this.element.addEventListener("input", () => {
      hiddenInput.value = telInput.getNumber(
        intlTelInputUtils.numberFormat.INTERNATIONAL
      );
    });

    this.element.addEventListener("countrychange", () => {
      hiddenInput.value = telInput.getNumber(
        intlTelInputUtils.numberFormat.INTERNATIONAL
      );
    });
  }
}
